import React from 'react';

const Footer = () => (
  <footer className="site-footer">
    <div>
      <a href="/legal/privacy-policy.html" target="_blank" rel="noopener noreferrer">Gizlilik Politikası</a>
      <span className="footer-separator">•</span>
      <a href="/legal/terms-of-service.html" target="_blank" rel="noopener noreferrer">Kullanım Şartları</a>
      <span className="footer-separator">•</span>
      <a href="/legal/cookie-policy.html" target="_blank" rel="noopener noreferrer">Çerez Politikası</a>
    </div>
    <div className="copyright">
      © 2025 Mindle TR – Türkiye'nin Günlük Bilgi Yarışması
    </div>
  </footer>
);

export default Footer;
